import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// Importar configuración de i18n
import './i18n/i18n';

// Exponer receptor para que la app Android pueda forzar la recarga de la sesión
// Android invocará: window.androidRefreshSession()
// Usamos any para evitar necesidad de declarar tipos globales
; (window as any).androidRefreshSession = function () {
  try {
    window.location.reload();
  } catch (e) {
    // noop
  }
};

// Exponer handler para que Android pase el idToken (y opcionalmente accessToken) de Google
// y la Web inicie sesión con Firebase Auth en el contexto del WebView.
// Uso desde Android (pseudocódigo):
//   webView.evaluateJavascript("window.androidSignInWithGoogle('" + idToken + "')", null)
; (window as any).androidSignInWithGoogle = async function (
  idToken: string,
  accessToken?: string
) {
  try {
    // Imports dinámicos para no alterar el orden de imports del archivo
    const { auth } = await import('./firebase/config');
    const { GoogleAuthProvider, signInWithCredential, setPersistence, browserLocalPersistence } = await import('firebase/auth');

    // Asegurar persistencia local en el WebView
    try {
      await setPersistence(auth, browserLocalPersistence);
    } catch (_) {
      // ignorar si ya está configurado
    }

    const credential = GoogleAuthProvider.credential(idToken, accessToken);
    await signInWithCredential(auth, credential);
    // Opcional: recargar para refrescar UI si la app lo necesita
    // window.location.reload();
    console.log('Sesión iniciada en WebView mediante androidSignInWithGoogle');
  } catch (e) {
    console.error('Error en androidSignInWithGoogle:', e);
  }
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Registrar el service worker para habilitar la funcionalidad PWA
// NO registrar en Android WebView porque causa loops infinitos
const isAndroidWebView = !!(window as any).Android;
if (!isAndroidWebView) {
  serviceWorkerRegistration.register({
    onSuccess: () => console.log('DomiRed está lista para uso offline'),
    onUpdate: () => console.log('Hay una nueva versión de DomiRed disponible')
  });
} else {
  // Desregistrar cualquier service worker existente en WebView
  serviceWorkerRegistration.unregister();
  console.log('Service worker desactivado en WebView Android');
}
